"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  contractIdFormat: true,
  parseContractIdFormat: true,
  formatContractId: true
};
exports.contractIdFormat = void 0;
exports.formatContractId = formatContractId;
exports.parseContractIdFormat = parseContractIdFormat;
var _chains = require("@blockwell/chains");
var _schema = require("./schema");
Object.keys(_schema).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _schema[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _schema[key];
    }
  });
});
const contractIdFormat = exports.contractIdFormat = /^([a-zA-Z0-9]+)[.\/](0x[a-fA-F0-9]{40})$/;
function parseContractIdFormat(value) {
  let match = contractIdFormat.exec(value);
  if (!match) {
    return null;
  }
  let chainId = (0, _chains.toChainId)(match[1]);
  if (chainId === 0) {
    return null;
  }
  return {
    chainId,
    address: match[2]
  };
}
function formatContractId(data) {
  let chainId;
  if ("chainId" in data) {
    chainId = (0, _chains.toChainId)(data.chainId);
  } else {
    chainId = (0, _chains.toChainId)(data.network);
  }
  return `${chainId}.${data.address.toLowerCase()}`;
}
//# sourceMappingURL=index.js.map